import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function sliderResults() {
  new Swiper('.swiper-events-more', {
    modules: [Navigation],
    grabCursor: true,
    initialSlide: 1,
    loop: true,
    spaceBetween: 24,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-buttons .swiper-button-next",
      prevEl: ".swiper-buttons .swiper-button-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      1110: {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 34,
      }
    }
  });
}
sliderResults();